import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  public source: string;

  @Input()
  public text: string;

  @Input()
  public disabled: boolean;

  @Input()
  public className = '';

  @Output()
  public clickHandler: EventEmitter<any>;

  @Input()
  set image(value: string) {
    this.source = value;
  }

  @Input()
  public spinner = false;

  constructor() {
    this.clickHandler = new EventEmitter();
  }

  /**
   * Maneja el evento de click del botón
   *
   * @param event evento click
   */
  public $clickHandler(event: Event): void {
    if (!this.disabled) {
      this.clickHandler.emit(event);
    }
  }
}
